import React from "react";
import { Container } from "../Common__style/Micro-style";
import FooterCompany from "./FooterCompany";
import FooterLinks from "./FooterLinks";
import FooterContacts from "./FooterContacts";
import FooterIcon from "./FooterIcon";
import * as F from "./Footer-style";


export default function Footer() {

   return (
      <F.Footer>
         <Container>
            <F.FooterBody>
               <FooterCompany />
               <FooterLinks />
               <FooterContacts />
               <FooterIcon />
            </F.FooterBody>
         </Container>
      </F.Footer >
   )
}